import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useUmbrella } from '@modules-deprecated/app/umbrellas'

export const useAutomaticPageTitle = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { organization } = useUserOrganization()
  const { umbrella } = useUmbrella()

  useEffect(() => {
    const observedElement = document.querySelector('.user-main') ?? document.body

    const updateTitle = () => {
      const h1Element = document.querySelector('.user-main h1')

      if (!h1Element) {
        return
      }

      const h1Text = h1Element.textContent
      let title: string

      if (organization?.name) {
        title = h1Text ? `${h1Text} - ${organization.name}` : organization.name
      } else if (umbrella?.id && h1Text) {
        title = `${h1Text} - ${umbrella.name}`
      } else {
        title = t('default_page_title')
      }

      if (document.title !== title) {
        document.title = title
      }
    }

    updateTitle()

    const observer = new MutationObserver(updateTitle)
    observer.observe(observedElement, { characterData: true, childList: true, subtree: true })

    return () => observer.disconnect()
  }, [location, organization, t, umbrella])
}
